import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp, FiMapPin, FiCalendar, FiUsers, FiAward, FiBookOpen, FiHome, FiStar } from "react-icons/fi";

class SingthaHistory extends Component {
    render() {
        return (
            <React.Fragment>
                <PageHelmet pageTitle='ประวัติบ้านสิงห์ท่า' />
                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.webp" />

                {/* Hero Section */}
                <div className="hero-section" style={{
                    background: 'linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url("/assets/images/singha/floor1/IMG_7801.webp")',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    minHeight: '60vh',
                    display: 'flex',
                    alignItems: 'center',
                    position: 'relative'
                }}>
                    <div className="container">
                        <div className="row justify-content-center text-center">
                            <div className="col-lg-8">
                                <h1 className="hero-title" style={{
                                    color: 'white',
                                    fontSize: '3.5rem',
                                    fontWeight: 'bold',
                                    marginBottom: '1rem',
                                    textShadow: '2px 2px 4px rgba(0,0,0,0.7)'
                                }}>
                                    ประวัติบ้านสิงห์ท่า
                                </h1>
                                <p className="hero-subtitle" style={{
                                    color: 'white',
                                    fontSize: '1.2rem',
                                    opacity: 0.9,
                                    textShadow: '1px 1px 2px rgba(0,0,0,0.7)'
                                }}>
                                    เรื่องราวการก่อตั้งเมืองเก่าที่มีประวัติศาสตร์ยาวนานมากกว่า 200 ปี
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Key Facts Section */}
                <div className="facts-section ptb--50" style={{ backgroundColor: 'white' }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <div className="section-title text-center mb-5">
                                    <h2 className="title" style={{
                                        fontSize: '2.5rem',
                                        fontWeight: 'bold',
                                        color: '#242424',
                                        marginBottom: '1rem'
                                    }}>
                                        ข้อมูลสำคัญ
                                    </h2>
                                    <p className="description" style={{
                                        fontSize: '1.5rem',
                                        color: '#666',
                                        maxWidth: '600px',
                                        margin: '0 auto'
                                    }}>
                                        ข้อมูลสำคัญเกี่ยวกับชุมชนเมืองเก่าบ้านสิงห์ท่า
                                    </p>
                                </div>

                                <div className="row">
                                    <div className="col-lg-3 col-md-6 mb-4">
                                        <div className="fact-card" style={{
                                            backgroundColor: '#f8f9fa',
                                            padding: '2rem',
                                            borderRadius: '15px',
                                            textAlign: 'center',
                                            height: '100%',
                                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                            cursor: 'pointer'
                                        }} onMouseEnter={(e) => {
                                            e.target.style.transform = 'translateY(-10px)';
                                            e.target.style.boxShadow = '0 20px 40px rgba(0,0,0,0.1)';
                                        }} onMouseLeave={(e) => {
                                            e.target.style.transform = 'translateY(0)';
                                            e.target.style.boxShadow = 'none';
                                        }}>
                                            <div className="fact-icon" style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '80px',
                                                height: '80px',
                                                backgroundColor: '#F45354',
                                                borderRadius: '50%',
                                                marginBottom: '1.5rem'
                                            }}>
                                                <FiCalendar style={{ color: 'white', fontSize: '2rem' }} />
                                            </div>
                                            <h3 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '0.5rem', color: '#F45354' }}>
                                                200+
                                            </h3>
                                            <p style={{ color: '#666', lineHeight: '1.6', fontSize: '1.1rem' }}>
                                                ปี ประวัติศาสตร์
                                            </p>
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-6 mb-4">
                                        <div className="fact-card" style={{
                                            backgroundColor: '#f8f9fa',
                                            padding: '2rem',
                                            borderRadius: '15px',
                                            textAlign: 'center',
                                            height: '100%',
                                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                            cursor: 'pointer'
                                        }} onMouseEnter={(e) => {
                                            e.target.style.transform = 'translateY(-10px)';
                                            e.target.style.boxShadow = '0 20px 40px rgba(0,0,0,0.1)';
                                        }} onMouseLeave={(e) => {
                                            e.target.style.transform = 'translateY(0)';
                                            e.target.style.boxShadow = 'none';
                                        }}>
                                            <div className="fact-icon" style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '80px',
                                                height: '80px',
                                                backgroundColor: '#F45354',
                                                borderRadius: '50%',
                                                marginBottom: '1.5rem'
                                            }}>
                                                <FiMapPin style={{ color: 'white', fontSize: '2rem' }} />
                                            </div>
                                            <h3 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '0.5rem', color: '#F45354' }}>
                                                2314
                                            </h3>
                                            <p style={{ color: '#666', lineHeight: '1.6', fontSize: '1.1rem' }}>
                                                ปี การก่อตั้ง
                                            </p>
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-6 mb-4">
                                        <div className="fact-card" style={{
                                            backgroundColor: '#f8f9fa',
                                            padding: '2rem',
                                            borderRadius: '15px',
                                            textAlign: 'center',
                                            height: '100%',
                                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                            cursor: 'pointer'
                                        }} onMouseEnter={(e) => {
                                            e.target.style.transform = 'translateY(-10px)';
                                            e.target.style.boxShadow = '0 20px 40px rgba(0,0,0,0.1)';
                                        }} onMouseLeave={(e) => {
                                            e.target.style.transform = 'translateY(0)';
                                            e.target.style.boxShadow = 'none';
                                        }}>
                                            <div className="fact-icon" style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '80px',
                                                height: '80px',
                                                backgroundColor: '#F45354',
                                                borderRadius: '50%',
                                                marginBottom: '1.5rem'
                                            }}>
                                                <FiUsers style={{ color: 'white', fontSize: '2rem' }} />
                                            </div>
                                            <h3 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '0.5rem', color: '#F45354' }}>
                                                ท้าวคำสู
                                            </h3>
                                            <p style={{ color: '#666', lineHeight: '1.6', fontSize: '1.1rem' }}>
                                                เจ้าเมืองคนแรก
                                            </p>
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-6 mb-4">
                                        <div className="fact-card" style={{
                                            backgroundColor: '#f8f9fa',
                                            padding: '2rem',
                                            borderRadius: '15px',
                                            textAlign: 'center',
                                            height: '100%',
                                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                            cursor: 'pointer'
                                        }} onMouseEnter={(e) => {
                                            e.target.style.transform = 'translateY(-10px)';
                                            e.target.style.boxShadow = '0 20px 40px rgba(0,0,0,0.1)';
                                        }} onMouseLeave={(e) => {
                                            e.target.style.transform = 'translateY(0)';
                                            e.target.style.boxShadow = 'none';
                                        }}>
                                            <div className="fact-icon" style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '80px',
                                                height: '80px',
                                                backgroundColor: '#F45354',
                                                borderRadius: '50%',
                                                marginBottom: '1.5rem'
                                            }}>
                                                <FiStar style={{ color: 'white', fontSize: '2rem' }} />
                                            </div>
                                            <h3 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '0.5rem', color: '#F45354' }}>
                                                2357
                                            </h3>
                                            <p style={{ color: '#666', lineHeight: '1.6', fontSize: '1.1rem' }}>
                                                ปี ยกฐานะเป็นเมือง
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Story Timeline Section */}
                <div className="story-timeline-section ptb--50" style={{ backgroundColor: '#f8f9fa' }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <div className="section-title text-center mb-5">
                                    <h2 className="title" style={{
                                        fontSize: '2.5rem',
                                        fontWeight: 'bold',
                                        color: '#242424',
                                        marginBottom: '1rem'
                                    }}>
                                        เรื่องราวการก่อตั้ง
                                    </h2>
                                    <p className="description" style={{
                                        fontSize: '1.5rem',
                                        color: '#666',
                                        maxWidth: '600px',
                                        margin: '0 auto'
                                    }}>
                                        ตามรอยการเดินทางและการก่อตั้งบ้านสิงห์ท่าจากจุดเริ่มต้น
                                    </p>
                                </div>

                                {/* Story Timeline */}
                                <div className="story-timeline" style={{ position: 'relative' }}>
                                    {/* Timeline Line */}
                                    <div className="timeline-line" style={{
                                        position: 'absolute',
                                        left: '50%',
                                        top: 0,
                                        bottom: 0,
                                        width: '4px',
                                        backgroundColor: '#F45354',
                                        transform: 'translateX(-50%)',
                                        zIndex: 1
                                    }}></div>

                                    {/* Story Items */}
                                    <div className="story-item" style={{
                                        display: 'flex',
                                        marginBottom: '4rem',
                                        position: 'relative',
                                        zIndex: 2
                                    }}>
                                        <div className="story-content left" style={{
                                            width: '45%',
                                            paddingRight: '3rem',
                                            textAlign: 'right'
                                        }}>
                                            <div className="story-card" style={{
                                                backgroundColor: 'white',
                                                padding: '2rem',
                                                borderRadius: '15px',
                                                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                                                borderLeft: '4px solid #F45354'
                                            }}>
                                                <div className="story-icon" style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    width: '60px',
                                                    height: '60px',
                                                    backgroundColor: '#F45354',
                                                    borderRadius: '50%',
                                                    marginBottom: '1rem'
                                                }}>
                                                    <FiMapPin style={{ color: 'white', fontSize: '1.5rem' }} />
                                                </div>
                                                <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '0.5rem', color: '#242424' }}>
                                                    พ.ศ. 2314
                                                </h3>
                                                <h4 style={{ fontSize: '1.2rem', fontWeight: '600', marginBottom: '1rem', color: '#F45354' }}>
                                                    การเดินทางจากเมืองหนองบัวลำภู
                                                </h4>
                                                <p style={{ color: '#666', lineHeight: '1.6' }}>
                                                    ท้าวคำสู ลูกหลานพระวอ พระตา ได้นำญาติพี่น้องและไพร่พลเดินทางจากเมืองหนองบัวลำภูลงมาเพื่อหาทำเลที่ตั้งเมืองใหม่ตามลำน้ำชี
                                                </p>
                                            </div>
                                        </div>
                                        <div className="story-dot" style={{
                                            position: 'absolute',
                                            left: '50%',
                                            top: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            width: '20px',
                                            height: '20px',
                                            backgroundColor: '#F45354',
                                            borderRadius: '50%',
                                            border: '4px solid white',
                                            boxShadow: '0 0 0 4px #F45354'
                                        }}></div>
                                        <div className="story-content right" style={{ width: '45%' }}></div>
                                    </div>

                                    <div className="story-item" style={{
                                        display: 'flex',
                                        marginBottom: '4rem',
                                        position: 'relative',
                                        zIndex: 2
                                    }}>
                                        <div className="story-content left" style={{ width: '45%' }}></div>
                                        <div className="story-dot" style={{
                                            position: 'absolute',
                                            left: '50%',
                                            top: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            width: '20px',
                                            height: '20px',
                                            backgroundColor: '#F45354',
                                            borderRadius: '50%',
                                            border: '4px solid white',
                                            boxShadow: '0 0 0 4px #F45354'
                                        }}></div>
                                        <div className="story-content right" style={{
                                            width: '45%',
                                            paddingLeft: '6rem'
                                        }}>
                                            <div className="story-card" style={{
                                                backgroundColor: 'white',
                                                padding: '2rem',
                                                borderRadius: '15px',
                                                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                                                borderRight: '4px solid #F45354'
                                            }}>
                                                <div className="story-icon" style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    width: '60px',
                                                    height: '60px',
                                                    backgroundColor: '#F45354',
                                                    borderRadius: '50%',
                                                    marginBottom: '1rem'
                                                }}>
                                                    <FiHome style={{ color: 'white', fontSize: '1.5rem' }} />
                                                </div>
                                                <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '0.5rem', color: '#242424' }}>
                                                    การตั้งถิ่นฐานชั่วคราว
                                                </h3>
                                                <h4 style={{ fontSize: '1.2rem', fontWeight: '600', marginBottom: '1rem', color: '#F45354' }}>
                                                    บ้านสิงห์โคก
                                                </h4>
                                                <p style={{ color: '#666', lineHeight: '1.6' }}>
                                                    เมื่อเดินทางมาถึงดงหัวช้างจึงทำพิธีเสี่ยงทายขอตั้งบ้านเมืองแต่ผลเสี่ยงทายทั้ง 3 ครั้งออกมาไม่ดี จึงทำการตั้งบ้านเรือนขึ้นชั่วคราวซึ่งคือบ้านสิงห์โคก
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="story-item" style={{
                                        display: 'flex',
                                        marginBottom: '4rem',
                                        position: 'relative',
                                        zIndex: 2
                                    }}>
                                        <div className="story-content left" style={{
                                            width: '45%',
                                            paddingRight: '3rem',
                                            textAlign: 'right'
                                        }}>
                                            <div className="story-card" style={{
                                                backgroundColor: 'white',
                                                padding: '2rem',
                                                borderRadius: '15px',
                                                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                                                borderLeft: '4px solid #F45354'
                                            }}>
                                                <div className="story-icon" style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    width: '60px',
                                                    height: '60px',
                                                    backgroundColor: '#F45354',
                                                    borderRadius: '50%',
                                                    marginBottom: '1rem'
                                                }}>
                                                    <FiAward style={{ color: 'white', fontSize: '1.5rem' }} />
                                                </div>
                                                <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '0.5rem', color: '#242424' }}>
                                                    การพบพระพุทธรูป
                                                </h3>
                                                <h4 style={{ fontSize: '1.2rem', fontWeight: '600', marginBottom: '1rem', color: '#F45354' }}>
                                                    หลวงพ่อสิงห์ฤทธิ์ปราบปวงมาร
                                                </h4>
                                                <p style={{ color: '#666', lineHeight: '1.6' }}>
                                                    เมื่อเวลาผ่านไปจึงออกเดินทางสำรวจเพื่อหาที่ตั้งเมืองอีกครั้งจนมาถึงพื้นที่ที่มีชื่อว่า ดงผีสิง บริเวณนั้นพบพระพุทธรูปขนาดใหญ่ซึ่งก็คือ <br></br>หลวงพ่อสิงห์ฤทธิ์ปราบปวงมาร
                                                </p>
                                            </div>
                                        </div>
                                        <div className="story-dot" style={{
                                            position: 'absolute',
                                            left: '50%',
                                            top: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            width: '20px',
                                            height: '20px',
                                            backgroundColor: '#F45354',
                                            borderRadius: '50%',
                                            border: '4px solid white',
                                            boxShadow: '0 0 0 4px #F45354'
                                        }}></div>
                                        <div className="story-content right" style={{ width: '45%' }}></div>
                                    </div>

                                    <div className="story-item" style={{
                                        display: 'flex',
                                        marginBottom: '4rem',
                                        position: 'relative',
                                        zIndex: 2
                                    }}>
                                        <div className="story-content left" style={{ width: '45%' }}></div>
                                        <div className="story-dot" style={{
                                            position: 'absolute',
                                            left: '50%',
                                            top: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            width: '20px',
                                            height: '20px',
                                            backgroundColor: '#F45354',
                                            borderRadius: '50%',
                                            border: '4px solid white',
                                            boxShadow: '0 0 0 4px #F45354'
                                        }}></div>
                                        <div className="story-content right" style={{
                                            width: '45%',
                                            paddingLeft: '6rem'
                                        }}>
                                            <div className="story-card" style={{
                                                backgroundColor: 'white',
                                                padding: '2rem',
                                                borderRadius: '15px',
                                                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                                                borderRight: '4px solid #F45354'
                                            }}>
                                                <div className="story-icon" style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    width: '60px',
                                                    height: '60px',
                                                    backgroundColor: '#F45354',
                                                    borderRadius: '50%',
                                                    marginBottom: '1rem'
                                                }}>
                                                    <FiStar style={{ color: 'white', fontSize: '1.5rem' }} />
                                                </div>
                                                <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '0.5rem', color: '#242424' }}>
                                                    การก่อตั้งบ้านสิงห์ท่า
                                                </h3>
                                                <h4 style={{ fontSize: '1.2rem', fontWeight: '600', marginBottom: '1rem', color: '#F45354' }}>
                                                    ผลเสี่ยงทายที่ดี
                                                </h4>
                                                <p style={{ color: '#666', lineHeight: '1.6' }}>
                                                    จึงทำการเสี่ยงทายตั้งเมืองอีกครั้งผลปรากฎว่าได้ผลดีทั้ง 3 ครั้ง จึงทำการตั้งบ้านสิงห์ท่าขึ้น โดยเจ้าคำสูเป็นผู้ปกครองบ้านสิงห์ท่านับตั้งแต่นั้นมา
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="story-item" style={{
                                        display: 'flex',
                                        marginBottom: '4rem',
                                        position: 'relative',
                                        zIndex: 2
                                    }}>
                                        <div className="story-content left" style={{
                                            width: '45%',
                                            paddingRight: '3rem',
                                            textAlign: 'right'
                                        }}>
                                            <div className="story-card" style={{
                                                backgroundColor: 'white',
                                                padding: '2rem',
                                                borderRadius: '15px',
                                                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                                                borderLeft: '4px solid #F45354'
                                            }}>
                                                <div className="story-icon" style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    width: '60px',
                                                    height: '60px',
                                                    backgroundColor: '#F45354',
                                                    borderRadius: '50%',
                                                    marginBottom: '1rem'
                                                }}>
                                                    <FiUsers style={{ color: 'white', fontSize: '1.5rem' }} />
                                                </div>
                                                <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '0.5rem', color: '#242424' }}>
                                                    พ.ศ. 2357
                                                </h3>
                                                <h4 style={{ fontSize: '1.2rem', fontWeight: '600', marginBottom: '1rem', color: '#F45354' }}>
                                                    การยกฐานะเป็นเมือง
                                                </h4>
                                                <p style={{ color: '#666', lineHeight: '1.6' }}>
                                                    พระบาทสมเด็จพระพุทธเลิศหล้านภาลัย ได้ทรงพระกรุณาโปรดเกล้าฯ ให้ยกบ้านสิงห์ท่าขึ้นเป็นเมืองและพระราชทานนามว่า <strong>เมืองยศสุนทร</strong> ให้เจ้าราชวงศ์สิงห์เป็นเจ้าครองเมืองมีราชทินนามว่า <br></br><strong>พระสุนทรราชวงศา</strong> <br></br>เป็นเจ้าเมืองคนแรกของเมืองยโสธร
                                                </p>
                                            </div>
                                        </div>
                                        <div className="story-dot" style={{
                                            position: 'absolute',
                                            left: '50%',
                                            top: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            width: '20px',
                                            height: '20px',
                                            backgroundColor: '#F45354',
                                            borderRadius: '50%',
                                            border: '4px solid white',
                                            boxShadow: '0 0 0 4px #F45354'
                                        }}></div>
                                        <div className="story-content right" style={{ width: '45%' }}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Detailed Content Section */}
                <div className="content-section ptb--50" style={{ backgroundColor: 'white' }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <div className="content-card" style={{
                                    backgroundColor: '#f8f9fa',
                                    padding: '3rem',
                                    borderRadius: '20px',
                                    boxShadow: '0 15px 35px rgba(0,0,0,0.1)'
                                }}>
                                    <h2 style={{
                                        fontSize: '2rem',
                                        fontWeight: 'bold',
                                        color: '#242424',
                                        marginBottom: '2rem',
                                        textAlign: 'center'
                                    }}>
                                        เรื่องราวโดยละเอียด
                                    </h2>
                                    
                                    <div className="content-paragraphs">
                                        <p style={{ color: '#666', lineHeight: '1.8', marginBottom: '1.5rem', fontSize: '1.5rem' }}>
                                            ชุมชนเมืองเก่าบ้านสิงห์ท่า เป็นชุมชนเก่าแก่ที่มีอายุมากกว่า 200 ปีริมฝั่งแม่น้ำชี ในประวัติศาสตร์ปรากฎร่องรอยการตั้งถิ่นฐานการอยู่อาศัยของคนตั้งแต่โบราณตามบันทึกที่จารึกอยู่ในปริวรรตใบลาน ได้จารึกเรื่องราวไว้ว่า เมื่อราว พ.ศ. 2314 ท้าวคำสู ลูกหลานพระวอ พระตา ได้นำญาติพี่น้องและไพร่พลเดินทางจากเมืองหนองบัวลำภูลงมาเพื่อหาทำเลที่ตั้งเมืองใหม่ตามลำน้ำชี
                                        </p>
                                        
                                        <p style={{ color: '#666', lineHeight: '1.8', marginBottom: '1.5rem', fontSize: '1.5rem' }}>
                                            เมื่อเดินทางมาถึงดงหัวช้างจึงทำพิธีเสี่ยงทายขอตั้งบ้านเมืองแต่ผลเสี่ยงทายทั้ง 3 ครั้งออกมาไม่ดี จึงทำการตั้งบ้านเรือนขึ้นชั่วคราวซึ่งคือบ้านสิงห์โคก ในตำบลสิงห์ อำเภอเมืองยโสธรในปัจจุบัน เมื่อเวลาผ่านไปจึงออกเดินทางสำรวจเพื่อหาที่ตั้งเมืองอีกครั้งจนมาถึงพื้นที่ที่มีชื่อว่า ดงผีสิง
                                        </p>
                                        
                                        <p style={{ color: '#666', lineHeight: '1.8', marginBottom: '1.5rem', fontSize: '1.5rem' }}>
                                            บริเวณนั้นพบพระพุทธรูปขนาดใหญ่ซึ่งก็คือ หลวงพ่อสิงห์ฤทธิ์ปราบปวงมารหรือพระเจ้าใหญ่ที่ประดิษฐานในพื้นที่วัดสิงห์ท่าปัจจุบัน จึงทำการเสี่ยงทายตั้งเมืองอีกครั้งผลปรากฎว่าได้ผลดีทั้ง 3 ครั้ง จึงทำการตั้งบ้านสิงห์ท่าขึ้น โดยเจ้าคำสูเป็นผู้ปกครองบ้านสิงห์ท่านับตั้งแต่นั้นมา
                                        </p>
                                        
                                        <p style={{ color: '#666', lineHeight: '1.8', fontSize: '1.5rem' }}>
                                            ก่อนได้ยกฐานะเป็นเมืองเมื่อ พ.ศ. 2357 พระบาทสมเด็จพระพุทธเลิศหล้านภาลัย ได้ทรงพระกรุณาโปรดเกล้าฯ ให้ยกบ้านสิงห์ท่าขึ้นเป็นเมืองและพระราชทานนามว่า <strong>เมืองยศสุนทร</strong> ให้เจ้าราชวงศ์สิงห์เป็นเจ้าครองเมืองมีราชทินนามว่า <strong>พระสุนทรราชวงศา</strong> เป็นเจ้าเมืองคนแรกของเมืองยโสธร
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>

                <Footer />

                {/* Mobile Responsive CSS */}
                <style jsx>{`
                    @media (max-width: 768px) {
                        .story-timeline {
                            padding: 0 1rem;
                        }
                        
                        .story-item {
                            flex-direction: column !important;
                            align-items: center !important;
                        }
                        
                        .story-content.left,
                        .story-content.right {
                            width: 100% !important;
                            padding: 0 !important;
                            text-align: center !important;
                            margin-bottom: 1rem;
                        }
                        
                        .story-card {
                            width: 100% !important;
                            margin: 0 !important;
                            padding: 1.5rem !important;
                            border-radius: 12px !important;
                        }
                        
                        .timeline-line {
                            display: none !important;
                        }
                        
                        .story-dot {
                            display: none !important;
                        }
                        
                        .hero-title {
                            font-size: 2.5rem !important;
                        }
                        
                        .hero-subtitle {
                            font-size: 1rem !important;
                        }
                        
                        .title {
                            font-size: 2rem !important;
                        }
                        
                        .description {
                            font-size: 1.2rem !important;
                        }
                        
                        .content-card {
                            padding: 2rem 1.5rem !important;
                            margin: 0 1rem !important;
                        }
                        
                        .content-paragraphs p {
                            font-size: 1.2rem !important;
                        }
                        
                        .fact-card {
                            padding: 1.5rem !important;
                        }
                        
                        .fact-icon {
                            width: 60px !important;
                            height: 60px !important;
                        }
                        
                        .fact-icon svg {
                            font-size: 1.5rem !important;
                        }
                    }
                    
                    @media (max-width: 480px) {
                        .story-card {
                            padding: 1rem !important;
                        }
                        
                        .hero-title {
                            font-size: 2rem !important;
                        }
                        
                        .title {
                            font-size: 1.8rem !important;
                        }
                        
                        .content-card {
                            padding: 1.5rem 1rem !important;
                        }
                        
                        .fact-card {
                            padding: 1rem !important;
                        }
                    }
                `}</style>
            </React.Fragment>
        )
    }
}

export default SingthaHistory;
